export default "__VITE_ASSET__CFPodh37__"